import { reactive } from "vue";

export const navFuntions = reactive({
  active: "home",
  mobileToggle: false,
  activeSection(value) {
    this.active = value;
    this.mobileToggle = false;
    const el = document.getElementById(value);
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: "smooth" });
  },
  activeNavCls(value) {
    return this.active == value ? "active" : "";
  },
  toggleMobileMenu() {
    this.mobileToggle = !this.mobileToggle;
  },
});
